module.exports = __webpack_public_path__ + "img/pic6.e8845d56.jpg";